import React from 'react';
import { stages, FAMILY_IMAGE } from '../data/content';
import { SectionLabel } from './ui/SectionLabel';
import { Reveal } from './ui/Reveal';
const toneClasses: Record<string, string> = {
  moss: 'bg-moss text-cream',
  ink: 'bg-ink text-cream',
  orange: 'bg-orange text-white'
};
export function Stages() {
  return <section className="bg-sand px-4 py-14 sm:px-5 sm:py-24" data-id="element-227" data-mp="1cc8en303sv46">
      <div className="mx-auto max-w-6xl" data-id="element-228" data-mp="2011f9cro7r54">
        <Reveal data-id="element-229" data-mp="2022pjf0v49ls">
          <SectionLabel data-id="element-230" data-mp="201jjavkkr9nl">Come avviene l’apprendimento</SectionLabel>
          <h2 className="display mx-auto mt-5 max-w-[24ch] text-center text-[1.7rem] text-ink sm:text-[3.1rem]" data-id="element-231" data-mp="24yt5m2co3577">
            Costruire non è il traguardo.{' '}
            <span className="text-orange" data-id="element-232" data-mp="1va1hy6en3723">
              È dove inizia l’apprendimento.
            </span>
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-center text-[15px] font-semibold leading-relaxed text-ink/65 sm:mt-5 sm:text-lg" data-id="element-233" data-mp="2iz3xn8ppqpty">
            Gli stessi tre passaggi si ripetono in ogni progetto, finché testare
            e migliorare un’idea diventa del tutto normale.
          </p>
        </Reveal>

        <div className="mt-9 grid gap-4 sm:mt-12 sm:gap-6 lg:grid-cols-[1.05fr_1fr] lg:items-stretch" data-id="element-234" data-mp="162icoape6u1i">
          <Reveal data-id="element-235" data-mp="1kqve3n79153e">
            <img src={FAMILY_IMAGE} alt="Un genitore e un bambino costruiscono insieme un robot di cartone al tavolo di casa" className="aspect-[4/3] h-full w-full rounded-[1.5rem] object-cover shadow-lift sm:rounded-[1.75rem] lg:aspect-auto" loading="lazy" width={1536} height={1024} data-id="element-236" data-mp="1krercqlyf5b3" />
          </Reveal>

          <ol className="grid gap-3.5 sm:gap-4" data-id="element-237" data-mp="1orowk11x9row">
            {stages.map((stage, index) => <Reveal key={stage.title} delay={index * 0.05} data-id="element-238" data-mp="23og1epud7vlw" data-mpi={index}>
                <li className={`flex h-full items-start gap-4 rounded-[1.5rem] p-6 sm:gap-5 sm:rounded-[1.75rem] sm:p-7 ${toneClasses[stage.tone]}`} data-id="element-239" data-mp="1yqnxexgg4j1c">
                  <span className="display mt-0.5 text-3xl opacity-40 sm:text-4xl" data-id="element-240" data-mp="9bzx3ul4qrjo">
                    {index + 1}
                  </span>
                  <div data-id="element-241" data-mp="u0iq1s1jvfbz">
                    <p className="text-[10px] font-black uppercase tracking-[0.18em] opacity-70" data-id="element-242" data-mp="u1akgzjev70o">
                      {stage.label}
                    </p>
                    <h3 className="display mt-1.5 text-xl sm:text-3xl" data-id="element-243" data-mp="y3xhdeuxvi4q">
                      {stage.title}
                    </h3>
                    <p className="mt-2 text-[15px] font-semibold leading-relaxed opacity-85 sm:mt-2.5 sm:text-base" data-id="element-244" data-mp="180thoxaooxy7">
                      {stage.description}
                    </p>
                  </div>
                </li>
              </Reveal>)}
          </ol>
        </div>
      </div>
    </section>;
}